"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAutoTestStep = void 0;
const maybe_1 = require("@codegrade/maybe");
const utils_1 = require("@/utils");
const utils_2 = require("./utils");
class BaseAutoTestStep {
    trackingId;
    id;
    description;
    name;
    type;
    weight;
    hidden;
    redacted;
    data;
    suite;
    constructor(data) {
        this.id = data.id;
        this.description = data.description;
        this.name = data.name;
        this.type = data.type;
        this.weight = data.weight;
        this.hidden = data.hidden;
        this.data = data.toParse ? this.parseInputData(data.data) : data.data;
        this.suite = data.suite;
        this.trackingId = data.trackingId.orDefaultLazy(utils_1.getUniqueId);
        this.redacted = data.redacted;
    }
    _update(data) {
        const newData = {
            id: this.id,
            description: data.description ?? this.description,
            name: data.name ?? this.name,
            type: this.type,
            weight: data.weight ?? this.weight,
            hidden: data.hidden ?? this.hidden,
            data: data.data ?? this.data,
            suite: this.suite,
            trackingId: maybe_1.Maybe.of(this.trackingId),
            toParse: false,
            redacted: this.redacted,
        };
        return new this.constructor(newData);
    }
    update(data) {
        return this._update(data);
    }
    updateData(partialData) {
        return this._update({
            data: {
                ...this.data,
                ...partialData,
            },
        });
    }
    _checkProgramNotEmpty() {
        if ((0, utils_2.isEmpty)(this.data.program)) {
            return ['The program may not be empty'];
        }
        return [];
    }
    _baseGetDataToSave() {
        const errs = [];
        if ((0, utils_2.isEmpty)(this.name)) {
            errs.push('The name may not be empty.');
        }
        if (Number(this.weight) < 0) {
            errs.push('The weight should not be negative.');
        }
        return (0, utils_2.errOrData)(errs, {
            name: this.name,
            id: this.id.extract(),
            description: this.description,
            hidden: this.hidden,
            weight: this.weight,
        });
    }
    equals(other) {
        if (this.id.isJust() && other.id.isJust()) {
            return this.id.equals(other.id);
        }
        return this.trackingId === other.trackingId;
    }
}
exports.BaseAutoTestStep = BaseAutoTestStep;
